<!-- https://vcalendar.io/ -->
<template>
	<div>
		<b-input-group v-if="today">
	        <div class="input-group-prepend">
	            <div class="btn input-group-text" @click="dateToday" v-b-tooltip.hover="$t('global.date_jour')">
	                <font-awesome-icon :icon="['fal', 'calendar']" />
	            </div>
	        </div>

			<date-picker
				v-model="model"
				:mode="mode"
				is24hr
				:locale="lang"
				color="pink"
				:popover="popover"
				:min-date="new Date('1900-01-01')"
				:max-date="new Date(4133894400000) /* 31 Dec 2100 */"
				:attributes='attributes'
				:masks="masks"
			>
				<template v-slot="{ inputValue, inputEvents }">
					<input
						v-on="inputEvents"
						type="text"
						class="form-control"
						:disabled="isDisabled"
						:value="inputValue"
					/>
				</template>
			</date-picker>
	    </b-input-group>

		<date-picker
			v-else
			v-model="model"
			:mode="mode"
			is24hr
			:locale="lang"
			color="pink"
			:popover="popover"
			:min-date="new Date('1900-01-01')"
			:max-date="new Date(4133894400000) /* 31 Dec 2100 */"
			:attributes='attributes'
			:masks="masks"
		>
			<template v-slot="{ inputValue, inputEvents }">
				<input
					v-on="inputEvents"
					type="text"
					class="form-control"
					:disabled="isDisabled"
					:value="inputValue"
				/>
			</template>
		</date-picker>
	</div>
</template>


<script>
// https://vcalendar.io/attributes.html
import Constants from 'Constants'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
	components: {
		'date-picker': DatePicker
	},
	name:'e-datepicker',
	props: {
		value:{
			type: Date,
			default: () => (new Date())
		},
		mode: {
			type: String,
			default: () => ('date')
		},
		popover: {
			type: Object,
			default: () => ({
				visibility: 'focus'
			})
		},
		disabled: {
			type: Boolean,
			default: () => ( false )
		},
		today: {
			type: Boolean,
			default: () => ( false )
		}
	},
	data(){
        return {
            attributes: [{
				key: 'today',
				dates: new Date(),
				highlight: {
					color: 'pink',
					fillMode: 'outline',
				},
			}],
			masks: {}
        }
    },
    mounted() {
    	let date_config = JSON.parse(window.localStorage.getItem('format_date')) ?? 'd/m/Y'
    	date_config = date_config.replace('Y', 'YYYY').replace('y', 'YY').replace('d', 'DD').replace('m', 'MM')
    	this.masks = {L: date_config}
    },
	computed: {
		model:{
			get () {
				return this.value
			},
			set (val) {
				this.$emit('input', val)
			}
		},
		isDisabled(){
			return this.disabled
		},
		lang(){
			return this.$store.state.user.lang
		}
	},
	methods: {
		dateToday() {
			this.model = new Date()
		}
	}
}
</script>
